import { render, staticRenderFns } from "./MpDetectAi.vue?vue&type=template&id=840b64c4&scoped=true&"
import script from "./MpDetectAi.vue?vue&type=script&lang=js&"
export * from "./MpDetectAi.vue?vue&type=script&lang=js&"
import style0 from "./MpDetectAi.vue?vue&type=style&index=0&id=840b64c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840b64c4",
  null
  
)

export default component.exports